import { push } from 'connected-react-router'
import { SERVICES_PAGE } from 'constant'

export const navigateToServices = () => (dispatch) => dispatch(push(SERVICES_PAGE))
